module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('symbol', {
    attrs: {
      "id": "pin-spot",
      "viewBox": "0 0 53.45 60.49"
    }
  }, [_c('path', {
    attrs: {
      "d": "M53.45,26.72A26.73,26.73,0,0,0,27,0,27,27,0,0,0,0,26.53a26.73,26.73,0,0,0,17.28,25.2,13.5,13.5,0,0,1,5.13,3.5,55.3,55.3,0,0,1,3.85,5,.62.62,0,0,0,1,0c1.5-1.79,3-3.84,4.61-5.47a13.75,13.75,0,0,1,4.77-3.24A26.74,26.74,0,0,0,53.45,26.72Z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "26.61",
      "cy": "26.58",
      "r": "14.71",
      "stroke": "#fff",
      "stroke-miterlimit": "10",
      "stroke-width": "8.5"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1c3611","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/decoration/visualization/spot_pin/default.vue
// module id = 626
// module chunks = 0